module.exports = __webpack_public_path__ + "static/media/pov_vertex_figure_Icosahedron.eee3f42c.png";